import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { ImportRate, Source } from '@helpers/types/models';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { exist } from '@campaign-portal/namespace/common/id';
import { ImportRatesService } from '../import-rates.service';
import { FileInfo } from '@campaign-portal/namespace/common/fileInfo';
import { FileParsedColumn, FilesParseResponse } from '@campaign-portal/namespace/entities/files/specs';
import { AlarisTableStateService, TABLE_STATE_SERVICE_INJECTOR } from '@campaign-portal/components-library';
import { BehaviorSubject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { ImportRatesFileService } from './import-rates-file.service';
import { SourcesService } from '../../sources/sources.service';

@Component({
	selector: 'app-import-rates-dialog',
	templateUrl: './import-rates-dialog.component.html',
	styleUrl: './import-rates-dialog.component.scss',
	providers: [
		AlarisTableStateService,
		{ provide: TABLE_STATE_SERVICE_INJECTOR, useExisting: AlarisTableStateService }
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class ImportRatesDialogComponent implements OnInit {

	private readonly destroyRef = inject(DestroyRef);
	file?: FileInfo;
	parsedFile: FilesParseResponse = {
		Success: false,
		Total: 1,
		Data: []
	};
	initialColumns: FileParsedColumn[] = [];
	columns: FileParsedColumn[] = [];
	readonly groups = new FormControl<ImportRate<exist>[] | null>([]);

	readonly loading$ = new BehaviorSubject<boolean>(false);

	readonly source = new FormControl('');
	sources: Source[] = [];
	readonly sourcesFilter = new FormControl();

	constructor(
		public readonly dataService: ImportRatesService,
		private readonly dialogRef: DialogRef<boolean>,
		public readonly importRates: ImportRatesFileService,
		public sourcesService: SourcesService
	) {
	}

	ngOnInit(): void {
		this.sourcesService.list$
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((list) => {
				if (list.length > 0) {
					this.sources = list;
				}
			});
		this.sourcesFilter.valueChanges
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((value) => {
				this.sources = this.sourcesService.list.filter((source) => {
					return source.Name.includes(value ?? '');
				});
			});
	}

	addFiles($event: (FileInfo | undefined)[]): void {
		if ( $event[0] ) {
			this.loading$.next(true);
			this.file = $event[0];
		} else {
			this.parsedFile.Success = false;
			this.file = undefined;
			this.columns = [];
			this.initialColumns = [];
			this.groups.setValue([]);
		}
	}

	confirm(): void {
		if (this.source.value && this.file) {
			this.importRates.uploadFile(this.source.value, this.file)
				.pipe(takeUntilDestroyed(this.destroyRef))
				.subscribe({
					next: () => this.dialogRef.close(true)
				});
		} else {
			return;
		}
	}

	close(): void {
		this.dialogRef.close(false);
	}
}
